import SqlTablesCard from "./SqlTablesCard";
import FileNamesCard from "./FileNamesCard";
import TableFieldsSection from "./TableFieldsSection";

export default function MappingForm() {
  return (
    <div className="ad-space-y-4">

      <h6 className="ad-page-title">Mapping Role</h6>

      {/* FORM GRID */}
      <div className="ad-grid-2">

        <div>
          <label className="ad-label">Company</label>
          <select className="ad-select">
            <option>--Select--</option>
          </select>
        </div>

        <div></div>

        <div>
          <label className="ad-label">User</label>
          <select className="ad-select">
            <option>Please Select</option>
          </select>
        </div>

        <div>
          <label className="ad-label">Role</label>
          <select className="ad-select">
            <option>Please Select</option>
          </select>
        </div>

      </div>

      {/* SQL + FILE */}
      <div className="ad-grid-2">
        <SqlTablesCard />
        <FileNamesCard />
      </div>

      {/* TABLE FIELDS */}
      <TableFieldsSection />

      <div style={{ textAlign: "right" }}>
        <button className="ad-btn ad-btn-green">Submit</button>
      </div>

    </div>
  );
}